import React from 'react';
import {Row, Col, Alert, Card, CardBody, Container, Button, Label} from 'reactstrap';
import {useForm} from 'react-hook-form';
import {useDispatch, useSelector} from 'react-redux';
import {Link, useNavigate} from 'react-router-dom';
import {userForgetPassword} from '../../store/actions';
import logoImg from '../../assets/images/logo-brother.svg';

const ForgetPasswordPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {forgetError, forgetSuccessMsg, loading} = useSelector((state) => state.ForgetPassword);

  const {register, handleSubmit, formState: {errors}} = useForm();

  const onSubmit = (data) => {
    dispatch(userForgetPassword(data, navigate));
  };

  return (
    <div className="account-pages my-5 pt-sm-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={6}>
            <Card className="overflow-hidden">
              <div className="bg-dark mb-4 p-4">
                <Row>
                  <Col className="col-7">
                    <div className="px-4">
                      <h3 className="text-yellow mb-0">Brother TECNET</h3>
                      <p className="text-white">
                        {process.env.REACT_APP_REALM.toUpperCase()} Dealer Service Platform
                      </p>
                    </div>
                  </Col>
                  <Col className="col-5 align-self-center text-right">
                    <div className="px-4">
                      <img src={logoImg} alt="logo" className="img-fluid" />
                    </div>
                  </Col>
                </Row>
              </div>
              <CardBody>
                <div className="p-2">
                  {forgetError && (
                    <Alert color="danger" style={{marginTop: '13px'}}>
                      {forgetError}
                    </Alert>
                  )}
                  {forgetSuccessMsg && (
                    <Alert color="success" style={{marginTop: '13px'}}>
                      {forgetSuccessMsg}
                    </Alert>
                  )}

                  <form className="form-horizontal mt-4" onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group">
                      <Label htmlFor="email">Email</Label>
                      <input
                        id="email"
                        type="email"
                        placeholder="Enter email"
                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                        {...register('email', {required: 'Email is required'})}
                      />
                      {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
                    </div>

                    <Row className="form-group">
                      <Col className="text-right">
                        <Button
                          className="btn btn-dark btn-block waves-effect waves-light"
                          type="submit"
                          disabled={loading}
                        >
                          {loading && <i className="bx bx-loader bx-spin font-size-16 align-middle mr-2" />}
                          Reset
                        </Button>
                      </Col>
                    </Row>
                  </form>
                </div>
              </CardBody>
            </Card>

            <div className="mt-5 text-center font-size-13">
              <p>
                Already have an account?{' '}
                <Link to="/login" className="font-weight-bold text-yellow">
                  Login
                </Link>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ForgetPasswordPage;
